/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import { withTranslation } from 'react-i18next'
import TextInput from '../../../common/form/TextInput'

import './LessonBasicDetails.scss'

class LessonBasicDetails extends React.Component {
  render() {
    const { t } = this.props
    const {
      lessonPlanName,
      defaultDuration,
      tagInput, // state of tag input
      textTags, // array of tags
      notes,
      video_url,
      onChange, // basic input handler
      textTagChange, // handler to check if user hits enter on tag input. if so, makes a tag
      removeTag, // function to act as click handler to remove tags
      photo, // data/info on photo => is an object with properties described below
      onChangePhoto, // handler to add photo
      clearPhoto, // function to remove the photo from state
      failedValidation, // array of what failed
      pageProgress, // page progress - the file input breaks if you set the value programmatically,
      // so coming BACK to this page after hitting next once doesn't set this value.
      is_admin, // whether or not the current user is an admin - controls if they can add a video
    } = this.props
    return (
      <div id='LessonBasicDetails'>
        <div className='outer-container'>
          <div className='picture-area'>
            <div className='picture-box'>
              <TextInput
                name={''}
                id={'input-photo-upload'}
                type={'file'}
                accept={'image/*'}
                className={'form-control-file photoInput hide'}
                onChange={onChangePhoto}
                placeholder={t('lessonPlans.basicDetails.addDifferentPhotoPlaceholder')}
                value={pageProgress > 1 ? '' : photo.uploadPhotoName}
                error={''}
              />
              {photo && photo.uploadPhotoFileSrc ? (
                <div className='photo-preview-container'>
                  <p className='remove-photo-button' onClick={clearPhoto}>
                    {t('lessonPlans.basicDetails.removePhoto')}{' '}
                    <i className='fa fa-times' aria-hidden='true' />
                  </p>
                  <div
                    className='center-cropped'
                    style={{
                      backgroundImage: 'url(' + photo.uploadPhotoFileSrc + ')',
                    }}
                  />
                </div>
              ) : (
                <div
                  className='text-center lp-photo-uploader'
                  onClick={this._selectInputFile}
                >
                  <i className='fa fa-picture-o' />
                  <p>{t('lessonPlans.basicDetails.clickToAddPhoto')}</p>
                </div>
              )}
            </div>
            {is_admin && (
              <div className='lp-video-container'>
                <label htmlFor='lp-video-input'>
                  {t('lessonPlans.basicDetails.templateVideoUrl')}
                </label>
                <input
                  type='text'
                  id='lp-video-input'
                  name='video_url'
                  value={video_url}
                  onChange={onChange}
                  placeholder={t('lessonPlans.basicDetails.urlHerePlaceholder')}
                />
              </div>
            )}
          </div>
          <div className='form-area'>
            <div className='form-box'>
              <div className='lp-name-container'>
                <label htmlFor='lp-name-input'>
                  {t('lessonPlans.basicDetails.lessonPlanName')}{' '}
                  <span className='orange-text'>*</span>
                </label>
                <input
                  type='text'
                  id='lp-name-input'
                  name='lessonPlanName'
                  value={lessonPlanName}
                  onChange={onChange}
                  placeholder={t('lessonPlans.basicDetails.lessonPlanName')}
                  maxLength={100}
                />
                <div className='failed-validation-box'>
                  {failedValidation.includes('name') && (
                    <p>
                      {t('lessonPlans.basicDetails.lessonPlanNameRequired')}
                    </p>
                  )}
                </div>
              </div>
              <div className='d-flex'>
                <div className='lp-default-duration-container'>
                  <label htmlFor='lp-default-duration-input'>
                    {t('lessonPlans.basicDetails.defaultSessionDuration')}
                  </label>
                  <input
                    onChange={onChange}
                    type='number'
                    id='lp-default-duration-input'
                    value={defaultDuration}
                    name='defaultDuration'
                    placeholder={t('lessonPlans.basicDetails.minutesPlaceholder')}
                    onWheel={e => e.target.blur()}
                    onBlur={
                      defaultDuration === ''
                        ? () =>
                          onChange({
                            target: { name: 'defaultDuration', value: 0 },
                          })
                        : () => false
                    }
                  />
                </div>
              </div>
              <div className='lp-text-tag-container'>
                <label htmlFor='lp-text-tag-input'>
                  {t('lessonPlans.basicDetails.textTags')}
                </label>
                <input
                  type='text'
                  id='lp-text-tag-input'
                  name='tagInput'
                  value={tagInput}
                  onChange={onChange}
                  onKeyUp={textTagChange}
                  placeholder={t('lessonPlans.basicDetails.pressEnterToAddTag')}
                  maxLength={25}
                />
              </div>
              <div className='tag-display-box'>
                {textTags.map((tag, index) => (
                  <p key={index} className='tag-bubble'>
                    {tag}
                    {'  '}
                    <span onClick={() => removeTag(index)}>
                      <i className='fa fa-times' aria-hidden='true' />
                    </span>
                  </p>
                ))}
              </div>
              <div className='lp-notes-container'>
                <label htmlFor='lp-notes-input'>
                  {t('common.field.notes')}
                </label>
                <textarea
                  id='lp-notes-input'
                  name='notes'
                  value={notes}
                  onChange={onChange}
                  placeholder={t('lessonPlans.basicDetails.addNotesPlaceholder')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _selectInputFile = () => {
    document.getElementById('input-photo-upload').click()
  }
}

export default withTranslation()(LessonBasicDetails)
